import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, deleteData, postData, uploadFile, putData } from '../../../webService/webservice.js';
import "../../../styles/Auth/service.css";
import ViewServicePopup from './ViewServicePopup.jsx';
const ServicePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddService = location.pathname === '/services/add';
    const role = sessionStorage.getItem("role");
    const adminStoreIds = JSON.parse(sessionStorage.getItem("storeIds") || "[]");
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Image',
        'Name',
        'Location',
        'Price',
        'Final Price',
        'Status',
        'Action',
    ];
    const [previewUrl, setPreviewUrl] = useState(null);
    const [serviceImage, setServiceImage] = useState(null);
    const [services, setServices] = useState([]);
    const [viewServiceData, setViewServiceData] = useState(null);
    const [servicesToDelete, setServicesToDelete] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = sessionStorage.getItem("Token");
    const userId = sessionStorage.getItem("userId");
    const [searchQuery, setSearchQuery] = useState('');
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editServiceId, setEditserviceId] = useState(null);
    const [employees, setEmployees] = useState([]);
    const initialStoreId = sessionStorage.getItem("currentStoreId") ||
        (role === "Admin" ? adminStoreIds[0] || "" : "");
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const [formData, setFormData] = useState({
        storeId: initialStoreId,
        serviceName: '',
        serviceCode: '',
        serviceImageObject: '',
        serviceCategory: '',
        serviceStatus: '',
        description: "",
        gstPercentage: 18,
        duration: '',
        basePrice: '',
        finalPrice: ''
    });

    const handleAddService = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const userId = sessionStorage.getItem("userId");
            if (serviceImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, serviceImage);

                if (uploadResult?.status === 200) {
                    // Build the full image URL
                    const serviceData = {
                        storeId: formData.storeId,
                        serviceName: formData.serviceName,
                        serviceCode: formData.serviceCode,
                        serviceImageObject: uploadResult?.data,
                        serviceCategory: formData.serviceCategory,
                        serviceStatus: formData.serviceStatus,
                        description: formData.description,
                        gstPercentage: formData.gstPercentage,
                        duration: formData.duration,
                        basePrice: formData.basePrice,
                        finalPrice: formData.finalPrice
                    };
                    console.log("Sending service data:", serviceData);

                    const response = await postData('services/', serviceData, token);

                    toast.success(response.message || 'Service added successfully');
                    setFormData({
                        storeId: '',
                        serviceName: '',
                        serviceCode: '',
                        serviceType: '',
                        serviceImageObject: '',
                        serviceCategory: '',
                        serviceStatus: '',
                        description: "",
                        gstPercentage: 18,
                        duration: '',
                        basePrice: '',
                        finalPrice: ''
                    });
                    setServiceImage(null);
                    setPreviewUrl(null);
                    navigate("/services");
                    triggerRefresh();
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                }
            }
        } catch (error) {
            console.error('Add Service Error:', error);
            toast.error(error.message || 'Add Service Failed');
        }
    };
    const handleViewservice = async (serviceId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("Token");

            // Fetch data using your getData function
            const response = await getData(`services/service/${serviceId}`, sessionToken);

            // Check if response is already JSON
            const data = response?.data || response;

            // Set the view data
            setViewServiceData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching Service:", error);
            toast.error(error.message || "Failed to fetch Service data");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchServices(currentPage, limit, searchQuery, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId]);
    const fetchServices = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            serviceName: searchQuery?.trim() || ""
        }
        if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData('services/services', params, sessionToken); // Your API route
            const resultsWrapper = response?.data?.[0];
            const servicesList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setServices(servicesList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch services");
        } finally {
            setLoading(false);
        }
    };
    const handleDeleteService = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('Token');
            const response = await deleteData(`services/service/${servicesToDelete}`, token);
            toast.success(response.message || "Service deleted successfully");
            setServicesToDelete(null);
            fetchServices(currentPage, limit, searchQuery, token);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Service");
        }
    }
    const handleUpdateService = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const userId = sessionStorage.getItem("userId");

            let updatedImageObject = formData.serviceImageObject;

            if (serviceImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, serviceImage);

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }
            const updatedServiceData = {
                serviceName: formData.serviceName,
                serviceCode: formData.serviceCode,
                serviceType: formData.serviceType,
                serviceImageObject: updatedImageObject,
                serviceCategory: formData.serviceCategory,
                serviceStatus: formData.serviceStatus,
                description: formData.description,
                duration: formData.duration,
                basePrice: formData.basePrice,
                finalPrice: formData.finalPrice,
                storeId: formData.storeId,
            };

            console.log("Updating Service with data:", updatedServiceData);

            const response = await putData(`services/service/${editServiceId}`, updatedServiceData, token);

            toast.success(response.message || 'Service updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                serviceName: '',
                serviceCode: '',
                serviceType: '',
                serviceImageObject: '',
                serviceCategory: '',
                serviceStatus: '',
                description: '',
                duration: '',
                basePrice: '',
                finalPrice: '',
                storeId: '',
            });
            setServiceImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchServices(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating service.");
        }
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);
    useEffect(() => {
        const storedStoreId = sessionStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFormData((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('users/users', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setEmployees(results);

            } catch (error) {
                console.error("Failed to load employees", error);
            }
        };
        fetchEmployees();
    }, []);
    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };


    const handleOpen = (serviceId) => {
        setServicesToDelete(serviceId);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setServicesToDelete(null);
    };



    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };
    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = sessionStorage.getItem("currentStoreId");
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };
        setLoading(true);
        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);
    return (
        <div className='service-layout'>
            <div className='service-content'>
                <main className='service-main'>
                    {isAddService ? (
                        <div className="add-Service-form">
                            <h3>Add Service</h3>
                            <form className="Service-form">
                                <div className="Service-form-row">
                                    <div className='Service-form-group'>
                                        <label className="input-label">Branch Name</label>
                                        <select
                                            className="category-input"
                                            value={formData.storeId || ""}
                                            onChange={(e) => {
                                                const storeId = e.target.value;
                                                setSelectedStoreId(storeId);
                                                setFormData(prev => ({ ...prev, storeId }));
                                                sessionStorage.setItem("currentStoreId", storeId);
                                                window.dispatchEvent(new Event("storeChanged"));
                                            }}
                                        >
                                            <option value="">Select Branch</option>
                                            {stores
                                                .filter(store =>
                                                    role === "SuperAdmin" ||
                                                    (role === "Admin" && adminStoreIds.includes(store._id))
                                                )
                                                .map(store => (
                                                    <option key={store._id} value={store._id}>
                                                        {store.storeName}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className="Service-form-group">
                                        <label htmlFor="ServiceImage" className="input-label">
                                            Service Image
                                        </label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id="ServiceImage"
                                            required
                                            disabled={!formData.storeId}
                                            name="ServiceImage"
                                            className="Service-input"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setServiceImage(file);
                                                setPreviewUrl(URL.createObjectURL(file));
                                            }}
                                        />
                                        {previewUrl && (
                                            <div className="image-preview">
                                                <img src={previewUrl} alt="Preview" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="Service-form-row">
                                    <div className="Service-form-group">
                                        <label htmlFor="serviceName" className="input-label">
                                            Service Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Service name"
                                            required
                                            className="Service-input"
                                            disabled={!formData.storeId}
                                            value={formData.serviceName}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, serviceName: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Service-form-group">
                                        <label className="input-label">Service Category</label>
                                        <select
                                            id="serviceCategory"
                                            className="category-input"
                                            required
                                            disabled={!formData.serviceName}
                                            value={formData.serviceCategory}
                                            onChange={(e) => {
                                                const selectedServiceCategory = e.target.value;
                                                setFormData((prev) => ({ ...prev, serviceCategory: selectedServiceCategory }))
                                            }}
                                        >
                                            <option value='' >Select Service Category</option>
                                            <option value='HairCut'>Hair Cut</option>
                                            <option value='SkinCare'>Skin Care</option>
                                            <option value='Spa'>Spa</option>
                                            <option value='Bridal'>Bridal</option>
                                            <option value='NailArt'>Nail Art</option>
                                            <option value='Makeup'>Makeup</option>
                                            <option value='BodyMassage'>Body Massage</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='Service-form-row'>
                                    <div className="Service-form-group">
                                        <div className="Service-form-group">
                                            <label htmlFor="basePrice" className="input-label">Price</label>
                                            <input
                                                type="text"
                                                name="basePrice"
                                                className="category-input"
                                                required
                                                disabled={!formData.serviceCategory}
                                                value={formData.basePrice}
                                                placeholder="Enter base price"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only numbers with optional decimal point
                                                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                        setFormData((prev) => ({ ...prev, basePrice: value }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="Service-form-group">
                                        <label htmlFor="finalprice" className="input-label">Final Price</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            disabled={!formData.basePrice}
                                            value={formData.finalPrice}
                                            onChange={(e) => setFormData((prev) => ({ ...prev, finalPrice: e.target.value }))}
                                        />
                                    </div>
                                </div>
                                <div className="Service-form-row">
                                    <div className="Service-form-group">
                                        <label htmlFor="gst" className="input-label">GST Value</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            required
                                            value={formData.gstPercentage}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, gstPercentage: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Service-form-group">
                                        <label htmlFor="duration" className="input-label">
                                            Time Duration (in minutes)
                                        </label>
                                        <input
                                            type="text"
                                            id="duration"
                                            className="category-input"
                                            placeholder="Enter duration in minutes"
                                            required
                                            disabled={!formData.finalPrice}
                                            value={formData.duration}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, duration: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="Service-form-row">
                                    <div className="Service-form-group">
                                        <label className="input-label">Service Status</label>
                                        <select
                                            id="serviceStatus"
                                            className="category-input"
                                            required
                                            disabled={!formData.duration}
                                            value={formData.serviceStatus}
                                            onChange={(e) => {
                                                const selectedServiceStatus = e.target.value;
                                                setFormData((prev) => ({ ...prev, serviceStatus: selectedServiceStatus }))
                                            }}
                                        >
                                            <option value='' >Select Service Status</option>
                                            <option value='Active'>Active</option>
                                            <option value='Inactive'>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="Service-form-group">
                                        <label htmlFor="description" className="input-label">
                                            Description
                                        </label>
                                        <input
                                            type="text"
                                            id="description"
                                            placeholder="Enter description"
                                            required
                                            disabled={!formData.serviceStatus}
                                            className="Service-input"
                                            value={formData.description}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, description: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="Service-buttons">
                                    <button className="add-Service-button" type="submit" onClick={handleAddService}>
                                        add Service
                                    </button>
                                    <button className="cancel-Service-button" onClick={() => navigate('/services')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>

                            <div className="service-widgets">
                                <div className="service-widgets-header">
                                    <h3>Services</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="service-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <button className="add-btn-service" onClick={() => navigate('/services/add')}>+ Add Service</button>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-service-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-service-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#F7EAE2',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {services.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No services found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            services.map((service, index) => (
                                                <TableRow key={service._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                            <img
                                                                src={`${process.env.REACT_APP_API_URL}${service.serviceImageObject?.uri}` || "/assets/placeholder.png"}
                                                                alt={service.name}
                                                                style={{ width: 40, height: 40, borderRadius: '4px' }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{service.serviceName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{service.storeDetails?.[0]?.storeName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{service.basePrice}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{service.finalPrice}</Typography></TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: service.isActive ? '#28A745' : '#C10000',
                                                                color: '#ffffff',
                                                                fontWeight: 600,
                                                                padding: '4px 8px',
                                                                borderRadius: '10px',
                                                                width: '90px',
                                                                maxHeight: '90px',
                                                                textTransform: 'none',
                                                                '&:hover': {
                                                                    backgroundColor: service.isActive ? '#218838' : '#a10000',
                                                                },
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                margin: '0 auto'
                                                            }}
                                                        >
                                                            {service.serviceStatus ? 'Active' : 'Inactive'}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => handleViewservice(service._id)} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    serviceName: service.serviceName,
                                                                    serviceCode: service.serviceCode,
                                                                    serviceType: service.serviceType,
                                                                    serviceImageObject: service.serviceImageObject,
                                                                    serviceCategory: service.serviceCategory,
                                                                    serviceStatus: service.serviceStatus,
                                                                    description: service.description,
                                                                    gstPercentage: service.gstPercentage,
                                                                    duration: service.duration,
                                                                    basePrice: service.basePrice,
                                                                    finalPrice: service.finalPrice,
                                                                    storeId: service.storeId?._id || service.storeId || "",
                                                                });
                                                                setPreviewUrl(
                                                                    service?.serviceImageObject?.uri
                                                                        ? `${process.env.REACT_APP_API_URL}${service.serviceImageObject.uri}`
                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                );
                                                                setServiceImage(null);
                                                                setEditserviceId(service._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                onClick={() => handleOpen(service._id)}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="service-bottom">
                                <div className="service-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="service-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="service-section spacer"></div>
                                <div className="service-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                        // icon={closeIcon}
                                        // className="popup-close-icon-outside"
                                        // onClick={() => {
                                        //     setIsPopupMode(false);
                                        //     setIsEditMode(false);
                                        //     setFormData({
                                        //         serviceName: '',
                                        //         serviceCode: '',
                                        //         serviceType: '',
                                        //         serviceImageObject: '',
                                        //         serviceCategory: '',
                                        //         serviceStatus: '',
                                        //         description: '',
                                        //         gstPercentage: '',
                                        //         duration: '',
                                        //         basePrice: '',
                                        //         finalPrice: '',
                                        //         storeId: '',
                                        //     });
                                        //     setPreviewUrl(null);
                                        // }}
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit service" : "Add service"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateService}>
                                                <div className="form-group-row">
                                                    <div className='Service-Input'>
                                                        <label className="input-label">Branch Name</label>
                                                        <select
                                                            className="category-input"
                                                            value={formData.storeId || ""}
                                                            onChange={(e) =>
                                                                setFormData(prev => ({ ...prev, storeId: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Branch</option>
                                                            {stores
                                                                .filter(store =>
                                                                    role === "SuperAdmin" ||
                                                                    (role === "Admin" && JSON.parse(sessionStorage.getItem("storeIds") || "[]").includes(store._id))
                                                                )
                                                                .map(store => (
                                                                    <option key={store._id} value={store._id}>
                                                                        {store.storeName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="ServiceImage" className="input-label">
                                                            Service Image
                                                        </label>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            id="ServiceImage"
                                                            name="ServiceImage"
                                                            className="Service-input"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                setServiceImage(file);
                                                                setPreviewUrl(URL.createObjectURL(file));
                                                            }}
                                                        />
                                                        {previewUrl && (
                                                            <div className="image-preview">
                                                                <img src={previewUrl} alt="Preview" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className='form-group-row'>
                                                    <div className="form-group">
                                                        <label htmlFor="serviceName" className="input-label">
                                                            Service Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Service name"
                                                            required
                                                            className="Service-input"
                                                            id="serviceName"
                                                            value={formData.serviceName}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, serviceName: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className='form-group'>
                                                        <label className="input-label">Service Category</label>
                                                        <select
                                                            id="serviceCategory"
                                                            className="category-input"
                                                            required
                                                            value={formData.serviceCategory}
                                                            onChange={(e) => {
                                                                const selectedServiceCategory = e.target.value;
                                                                setFormData((prev) => ({ ...prev, serviceCategory: selectedServiceCategory }))
                                                            }}
                                                        >
                                                            <option value='' >Select Service Category</option>
                                                            <option value='HairCut'>Hair Cut</option>
                                                            <option value='SkinCare'>Skin Care</option>
                                                            <option value='Spa'>Spa</option>
                                                            <option value='Bridal'>Bridal</option>
                                                            <option value='NailArt'>Nail Art</option>
                                                            <option value='Makeup'>Makeup</option>
                                                            <option value='BodyMassage'>Body Massage</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="basePrice" className="input-label">Base Price</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.basePrice}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, basePrice: value }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="finalprice" className="input-label">Final Price</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.finalPrice}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, finalPrice: value }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="gst" className="input-label">GST Value</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            disabled
                                                            value={formData.gstPercentage}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, gstPercentage: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="duration" className="input-label">
                                                            Time Duration (in minutes)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="duration"
                                                            className="category-input"
                                                            placeholder="Enter duration in minutes"
                                                            value={formData.duration}
                                                            onChange={(e) =>
                                                                setFormData(prev => ({ ...prev, duration: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Service Status</label>
                                                        <select
                                                            id="serviceStatus"
                                                            className="category-input"
                                                            required
                                                            value={formData.serviceStatus}
                                                            onChange={(e) => {
                                                                const selectedServiceStatus = e.target.value;
                                                                setFormData((prev) => ({ ...prev, serviceStatus: selectedServiceStatus }))
                                                            }}
                                                        >
                                                            <option value='' >Select Service Status</option>
                                                            <option value='Active'>Active</option>
                                                            <option value='Inactive'>Inactive</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="description" className="input-label">
                                                            Description
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="description"
                                                            placeholder="Enter description"
                                                            className="Service-input"
                                                            value={formData.description}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, description: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update service" : "Add service"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && services.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more services
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this service?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteService}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && (
                                <ViewServicePopup
                                    data={viewServiceData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}
                        </>
                    )
                    }
                </main >
            </div >
        </div >
    );
};

export default ServicePage;